import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';
import { canOpen } from '@/lib/navAccess';

/**
 * Route guard. It decides what is OFFERED; the server decides what is returned. A user who
 * reaches a screen they hold no permission for still sees an empty grid, because RLS says so -
 * this only spares them the trip.
 */
export function RequireAuth({ children, navKey }: { children: ReactNode; navKey?: string }) {
  const { status, profile } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <div className="shell-loading">Loading your workspace...</div>;
  if (status === 'offline') return <>{children}</>;            // no backend configured: prototype shell
  if (status !== 'active') {
    return <Navigate replace state={{ from: location.pathname }} to="/login" />;
  }
  if (navKey && !canOpen(profile, navKey)) {
    return (
      <div className="card">
        <h2>Not available to your role</h2>
        <p>
          Your role does not include this screen. If you need it, ask your organisation admin to
          grant the permission.
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
